module.exports = __webpack_public_path__ + "media/images/app/become-vendor/Vendor-MidImage-5121bfd0f57dcad727731ee6c119f028.webp";